const key = "product"

export function selectProduct(state) {
	return state[key]
}

export function selectProductQuantity(state) {
  return selectProduct(state).quantity
}
export function selectProductInfo(state) {
  return selectProduct(state).info
}
export function selectProductSelection(state) {
  return selectProduct(state).selection
}